import { FC } from 'react';
import { useIntl } from 'react-intl';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { useContractSettingListingPage } from './contract-setting-listing-page.hook';
import { ContractSettingList } from './components/contract-setting-list.component';

type ContractSettingListingPageProps = ParamsProps;

export const ContractSettingListingPage: FC<ContractSettingListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  const { filterState, contractSettingList, isLoading, setFilterState, refreshData, onSort } =
    useContractSettingListingPage({
      initialParams,
      onChangeQueryParams,
    });

  return (
    <>
      <PruFilter
        title={Translation('contract.setting.filter')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'productName',
            initialValue: filterState.productName,
            displayName: Translation('master.data.setting.name.PRODUCT_NAME'),
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            page: 1,
            productName: data.productName,
          })
        }
        fetchData={refreshData}
      />
      <ContractSettingList
        isLoading={isLoading}
        contractSettingList={contractSettingList}
        onRefresh={refreshData}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
        onSort={onSort}
      />
    </>
  );
};
